export default {
    TAGS_ARRAY: [
      { value: "", text: "" },
      { value: 0, text: "Авторский" },
      { value: 1, text: "Новинка" },
      { value: 2, text: "Монобукет" }, 
      { value: 3, text: "Букет с витрины" },
      { value: 4, text: "Срочная доставка" },
      { value: 5, text: "Premium " }, 
      { value: 6, text: "Букет - комплимент" },
      { value: 7, text: "Хит продаж" },
      { value: 8, text: "Акция" }, 
      { value: 9, text: "Ароматный " },
      { value: 10, text: "Крашеный" },
      { value: 11, text: "В сезон" },
      { value: 12, text: "Органик" },
    ],

    PROMO_RULE: [
      { value: null, text: "Нет" }, 
      { value: 0, text: "Покупка от 1000р" }, 
      { value: 1, text: "Покупка от 2000р" }, 
      { value: 2, text: "Покупка от 3000р" }, 
      { value: 3, text: "Покупка от 4000р" }, 
      { value: 4, text: "Покупка от 5000р" }, 
      { value: 5, text: "Покупка от 6000р" }, 
      { value: 6, text: "Покупка от 7000р" }, 
      { value: 7, text: "Покупка от 8000р" }, 
      { value: 8, text: "Покупка от 9000р" }, 
      { value: 9, text: "Покупка от 10000р" }, 
    ],

  PROMO_RULE_ZERO: [ 
      { value: 0, text: "Покупка от 1000р" }, 
      { value: 1, text: "Покупка от 2000р" }, 
      { value: 2, text: "Покупка от 3000р" }, 
      { value: 3, text: "Покупка от 4000р" }, 
      { value: 4, text: "Покупка от 5000р" }, 
      { value: 5, text: "Покупка от 6000р" }, 
      { value: 6, text: "Покупка от 7000р" }, 
      { value: 7, text: "Покупка от 8000р" }, 
      { value: 8, text: "Покупка от 9000р" }, 
      { value: 9, text: "Покупка от 10000р" }, 
    ],
    
}